import React from "react";
import { Phone, Mail, MapPin, ArrowRight } from "lucide-react";
import { CONTACT } from "../mock";

const Contact = () => {
  const items = [
    { icon: Phone, label: "Call Us", value: CONTACT.phone, href: `tel:${CONTACT.phone}` },
    { icon: Mail, label: "Email", value: CONTACT.email, href: `mailto:${CONTACT.email}` },
    { icon: MapPin, label: "Location", value: CONTACT.address, href: null },
  ];

  return (
    <section id="contact" className="py-20 lg:py-28 bg-[var(--soft)]">
      <div className="max-w-5xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <span className="text-sm font-bold uppercase tracking-wider text-[var(--brand)]">
            Get In Touch
          </span>
          <h2 className="mt-3 font-heading text-4xl lg:text-5xl font-extrabold leading-tight tracking-tight text-[var(--ink)]">
            Let's start sourcing together
          </h2>
          <p className="mt-4 text-lg text-[var(--muted-ink)]">
            Have a sourcing requirement or a product idea? Drop us an email and a dedicated
            representative will respond within 8 hours.
          </p>

          <a
            href={`mailto:${CONTACT.email}`}
            className="group mt-8 inline-flex items-center gap-2 rounded-full bg-[var(--brand)] px-8 py-4 font-bold text-white shadow-lg shadow-[var(--brand)]/30 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl"
          >
            <Mail size={19} />
            Email Us
            <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
          </a>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {items.map((it) => {
            const Icon = it.icon;
            const content = (
              <div className="flex h-full flex-col items-center gap-4 rounded-2xl bg-white p-8 text-center shadow-[0_4px_20px_rgba(17,17,26,0.05)] transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_18px_40px_rgba(108,92,231,0.14)]">
                <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[var(--brand)]/10 text-[var(--brand)]">
                  <Icon size={26} />
                </span>
                <div>
                  <p className="text-xs font-bold uppercase tracking-wider text-[var(--muted-ink)]">
                    {it.label}
                  </p>
                  <p className="mt-2 font-semibold text-[var(--ink)] break-words">{it.value}</p>
                </div>
              </div>
            );
            return it.href ? (
              <a key={it.label} href={it.href} className="block h-full">
                {content}
              </a>
            ) : (
              <div key={it.label} className="h-full">
                {content}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Contact;
